// extracted by mini-css-extract-plugin
export default {"showMore":"ShowMore_showMore__5YyCQ","icon":"ShowMore_icon__BAsBq"};